import React, { useContext, useState } from "react";
import { QK } from "../../../base/qk";
import { useMutation, useQuery, useQueryClient } from "react-query";
import {
  getDolsList,
  getHealthAssesments,
} from "../../../api/services/notification";
import TableComponent from "../../TableComponent/TableComponent";
import { formatDateField, formatDateTime } from "../../../base/FormatTime";
import { Delete } from "@mui/icons-material";
import { deleteDols } from "../../../api/services/document";
import { useSnackbar } from "notistack";
import ConfirmModal from "../../ConfirmModal/ConfirmModal";
import MyContext from "../../../context/MyContext";

const DolsContent = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedDols, setSelectedDols] = useState(null);
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();
  const { locationID } = useContext(MyContext);

  const dolsPerPage = 10;

  const { data: dols, isLoading } = useQuery(
    [QK.dolsList, currentPage, locationID],
    () => getDolsList(currentPage, locationID),
    { keepPreviousData: true, enabled: !!currentPage || !!locationID }
  );

  const totalRecords = dols?.count || 0;
  const totalPages = Math.ceil(totalRecords / dolsPerPage);

  const handlePageChange = (event, page) => setCurrentPage(page);

  const handleDelete = (id) => {
    setShowConfirmModal(true);
    setSelectedDols(id);
  };

  const deleteDolsMutation = useMutation(deleteDols, {
    onSuccess: () => {
      queryClient.invalidateQueries([QK.dolsList]);
      enqueueSnackbar("Dols deleted successfully", { variant: "success" });
    },
    onError: () => {
      enqueueSnackbar("Failed to delete Dols", { variant: "error" });
    },
  });

  const handleDolsDeleteConfirm = () => {
    if (selectedDols) {
      deleteDolsMutation.mutate(selectedDols);
    }
    setShowConfirmModal(false);
  };

  const columns = [
    {
      field: "renewal_date",
      headerName: "Expiry Date",
      render: (value) => formatDateField(value),
    },
    { field: "client_name", headerName: "Service User" },
    { field: "note_message", headerName: "Comment" },
  ];
  const actions = [
    {
      icon: <Delete />,
      color: "error",
      handler: (dols) => handleDelete(dols.id),
    },
  ];

  return (
    <div>
      <TableComponent
        columns={columns}
        data={dols?.results || []}
        isLoading={isLoading}
        pagination={{ totalPages, currentPage }}
        onPageChange={handlePageChange}
        actions={actions}
        size="small"
      />
      <ConfirmModal
        show={showConfirmModal}
        handleClose={() => setShowConfirmModal(false)}
        handleConfirm={handleDolsDeleteConfirm}
        title="Delete Confirmation"
        body="Are you sure you want to delete this Dols?"
      />
    </div>
  );
};

export default DolsContent;
